import { css } from 'styled-components'

const Theme = {
  body_background_color: '#17ABDD',
  header_border_color: '#eee',

  logo_image_url: 'megamigs.png',
  logo_height: 120,

  token_url: 'megamigs.png',
  number_hidden: true,

  button_color: '#da2b1d',
  button_radius: 15,
  button_no_border: true,
  button_hover_color: '#971910',
  button_hover_text_color: 'white',
  button_outlined_color: '#971910',
  button_outlined_text_color: 'white',
  button_outlined_hover_color: '#da2b1d',
  button_outlined_hover_text_color: 'white',

  title_font: `'Rajdhani', sans-serif`,
  title_weight: 700,
  title_size: 28,
  title_lineheight: 28,

  subtitle_weight: 500,
  subtitle_size: 20,
  subtitle_lineheight: 20,
  subtitle_color: '#4D4185',

  text_font: `'Rajdhani', sans-serif`,
  text_size: 16,
  text_lineheight: 23.8,

  footer_border_color: 'transparent',
  footer_background_color: '#362A6F',
  footer_text_color: 'white',
  footer_text_size: 13,
  custom_footer_image: css`
    margin: 0;
    padding-top: 0;
    overflow: hidden;

    img {
      max-height: 123px;
      margin: 0;
    }
  `,

  custom_min_height: 290,
}

export default Theme
